module.exports = __webpack_public_path__ + "img/charging2.0872f7cf.png";